import {RSAA} from 'redux-api-middleware';
import { CANDIDATE_ACTIVATION_PENDING, 
        CANDIDATE_ACTIVATION_SUCCESS, 
        CANDIDATE_ACTIVATION_FAILURE } from '../actions/accountActions';
const statusResource = {
  resource: "/user/reactivateUser",
  contentType: "application/json"
}
export function candidateAccountReactivation(token) {
    return {
        [RSAA]: {
            endpoint: statusResource.resource,
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              userName: null,
              token: token
          }),
                types: [
              CANDIDATE_ACTIVATION_PENDING, 
              CANDIDATE_ACTIVATION_SUCCESS,
              CANDIDATE_ACTIVATION_FAILURE
            ]
          }
    }
}